import AxiosService from 'plugins/TS-lib-utils-public/services/AxiosService';

class msLabsService extends AxiosService {
  constructor() {
    super('labs');
  }

    uploadStudyFile = async (doctorEmail, patientEmail, practiceId, studyFile, studyType, { cancelToken = null } = {}) => {

        let formData = new FormData();
        formData.append("doctor_email", doctorEmail);
        formData.append("patient_email", patientEmail);
        formData.append("practice", practiceId);
        formData.append("file", studyFile);
        formData.append("type", studyType);

        return await this.post(`/hl7/manualfile${studyType === "auto" ? "auto" : ""}`, formData, {
            timeout: Infinity,
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                "Content-Type": "multipart/form-data",
            },
            cancelToken: cancelToken
        });
    }
}

export default new msLabsService();





